import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './ProfitAndLoss.css'
import { useParams } from "react-router-dom";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function ProfitAndLoss() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [groupValue, setGroupValue] = useState("Consolidated");
    const [co_code, setco_code] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const { getCompName } = useParams();
    const [nameCom, setNameCom] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [data, setData] = useState([]);
    const [dataSort, setDataSort] = useState([]);
    const [dataSort1, setDataSort1] = useState([]);
    const [dataSort2, setDataSort2] = useState([]);
    const [dataSort3, setDataSort3] = useState([]);
    const [dataSort4, setDataSort4] = useState([]);
    const [dataCol, setDataCol] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, getDataCol;
    const [loadingshow, setloadingshow] = useState(false);
    let PageSize = 7;
    let arrayData = [], arrayDataCol = [], arrayColumnData = [];
    let arrayColumn = [];
    let dataGet, finalData, dataGet1, finalData1, dataGet2, finalData2;
    let dataGet3, finalData3, dataGet4, finalData4;
    useEffect(() => {
        if (co_code != '') {
            if (groupValue === "Consolidated") {
                const getUrl = BaseURL + "BalanceSheet";
                fetch(`${getUrl}/${co_code}/p/5`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false);
                        // console.log(getData, "ProfitAndLoss")
                    })
                    .catch((error) => {
                    });
                const getUrlCol = BaseURL + "BalanceSheetCol";
                fetch(`${getUrlCol}/${co_code}/P/5`)
                    .then((response) => response.json())
                    .then((dataCol) => {
                        getDataCol = dataCol.data;
                        setDataCol(getDataCol);
                        //console.log(getDataCol, "BalanceSheetCol");
                        if (getDataCol[2].slice(-2) === "12") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "Dec " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[2].slice(-2) === "03") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "March " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "12") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "Dec " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[3].slice(-2) === "03") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "March " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "12") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "Dec " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[4].slice(-2) === "03") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "March " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "12") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "Dec " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "March " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[6].slice(-2) === "12") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "Dec " + dataGet4;
                            setDataSort4(finalData4);
                        }
                        if (getDataCol[6].slice(-2) === "03") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "March " + dataGet4;
                            setDataSort4(finalData4);
                        }
                    })
                    .catch((error) => {
                    });
            } else {
                const getUrl = BaseURL + "BalanceSheetStandard";
                fetch(`${getUrl}/${co_code}/p/5`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        // console.log(getData, "ProfitAndLoss")
                        setloadingshow(false);
                    })
                    .catch((error) => {
                    });
                const getUrlCol = BaseURL + "BalanceSheetColStandard";
                fetch(`${getUrlCol}/${co_code}/p/5`)
                    .then((response) => response.json())
                    .then((dataCol) => {
                        getDataCol = dataCol.data;
                        setDataCol(getDataCol);
                        setloadingshow(false);
                        // console.log(getDataCol, "BalanceSheetCol");
                        if (getDataCol[2].slice(-2) === "12") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "Dec " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[2].slice(-2) === "03") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "March " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "12") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "Dec " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[3].slice(-2) === "03") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "March " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "12") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "Dec " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[4].slice(-2) === "03") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "March " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "12") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "Dec " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "March " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[6].slice(-2) === "12") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "Dec " + dataGet4;
                            setDataSort4(finalData4);
                        }
                        if (getDataCol[6].slice(-2) === "03") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "March " + dataGet4;
                            setDataSort4(finalData4);
                        }
                    })
                    .catch((error) => {
                    });
            }
        }
    }, [co_code, groupValue])

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);

    if (data != null) {
        for (let [key, value] of Object.entries(data)) {
            for (let [key, value] of Object.entries(value)) {
                arrayDataCol.push(<td>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value) : '-'}</td>);
            }
            arrayData.push(<tr>{arrayDataCol}</tr>);
            arrayColumn.push(<tr>{arrayColumnData}</tr>);
            arrayDataCol = [];
            arrayColumnData = [];
        }
    }
    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Profit & Loss</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Profit And Loss</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Profit & Loss Accounts" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom : ''}</h4>
                            </div>
                            <div className='key-right'>
                                <div className='key-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="Consolidated" selected>Consolidated</option>
                                        <option value="Standalone">Standalone</option>
                                    </select>
                                </div>
                            </div>
                            <div className="table-class">
                                <div className='Buyer-sel-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            {/* {arrayColumn[0]} */}
                                            {(dataCol === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}

                                            {dataCol != null ?
                                                <tr>
                                                    <th>Particulars</th>
                                                    <th>{dataSort}<br></br> (₹ in Cr.)</th>
                                                    <th>{dataSort1}<br></br> (₹ in Cr.)</th>
                                                    <th>{dataSort2}<br></br> (₹ in Cr.)</th>
                                                    <th>{dataSort3}<br></br> (₹ in Cr.)</th>
                                                    <th>{dataSort4}<br></br> (₹ in Cr.)</th>
                                                </tr> : ''
                                            }
                                        </thead>
                                        <tbody>
                                            {arrayData}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                                {/* {(data != null && data != []) ?
                                    <Pagination
                                        className="pagination-bar_peer"
                                        currentPage={currentPage}
                                        totalCount={(data.length != null) ? data.length : 0}
                                        pageSize={PageSize}
                                        onPageChange={page => setCurrentPage(page)}
                                    /> : <p className="errorPeer"> No Data Found !!! </p>} */}
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default ProfitAndLoss

